export default __webpack_public_path__ + "static/media/Original Crop Easy.8c03cd2d.png";